<template>
  <div>
    <v-container fluid>
      <div class="text-xs-right">
        <v-btn @click="createEmp" depressed color="primary">สร้าง</v-btn>
      </div>
      <v-data-table
        expand
        :loading="loading"
        v-bind:pagination.sync="pagination"
        :headers="headers"
        :items="desserts"
        class="elevation-1 scgallrenttable"
      >
        <template v-slot:items="props">
          <tr @click="showictdevices(props.item.emp_id)" style="cursor: pointer">
            <td class="text-xs-center">{{ props.item.emp_id }}</td>
            <td class="text-xs-center" style="white-space: nowrap">
              {{ props.item.emp_title }}{{ props.item.emp_first_name }}
              {{ props.item.emp_last_name }} {{ `(${props.item.emp_nickname})` }}
            </td>
            <td class="text-xs-center">{{ props.item.emp_fullname_en }}</td>
            <td class="text-xs-center">{{ props.item.position_name }}</td>
            <td class="text-xs-center">{{ props.item.department_name }}</td>
            <td class="text-xs-center">{{ props.item.emp_email }}</td>
            <td class="text-xs-center">{{ props.item.emp_phoneno | phonefilter }}</td>
            <td class="text-xs-center" style="white-space: nowrap">
              <span
                @click.stop="onClickeditemp(props.item)"
                :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 19px`"
                class="material-icons"
                >create</span
              >
              <span
                @click.stop="deletepttlnguserprofile(props.item)"
                :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 19px`"
                class="material-icons"
                >delete_forever</span
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="showeditemp" width="550px" persistent>
      <div>
        <v-card>
          <div class="text-xs-right">
            <v-btn @click="closeedit" icon>
              <v-icon>close</v-icon>
            </v-btn>
          </div>
          <v-card-text v-if="showeditemp">
            <div class="form-control" :class="{ 'has-error': errors.has('คำนำหน้า') }">
              <label>คำนำหน้าชื่อ</label>
              <v-radio-group
                v-validate="'required'"
                name="คำนำหน้า"
                :data-vv-as="'Title'"
                color="primary"
                row
                v-model="inputedit.emp_title"
              >
                <v-radio color="primary" :label="'นาย'" :value="'นาย'"></v-radio>
                <v-radio color="primary" :label="'นาง'" :value="'นาง'"></v-radio>
                <span class="text-error" v-if="errors.has('คำนำหน้า')">{{
                  errors.first('คำนำหน้า')
                }}</span>
              </v-radio-group>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('ID name') }">
              <label>ID</label>
              <input
                v-validate="'required'"
                name="ID name"
                :disabled="edittype == 'update'"
                :readonly="edittype == 'update'"
                :data-vv-as="'ID name'"
                type="text"
                v-model="inputedit.emp_id"
              />
              <span class="text-error" v-if="errors.has('ID name')">{{
                errors.first('ID name')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Firstname') }">
              <label>ชื่อจริง</label>
              <input
                v-validate="'required'"
                name="Firstname"
                :data-vv-as="'Firstname'"
                type="text"
                v-model="inputedit.emp_first_name"
              />
              <span class="text-error" v-if="errors.has('Firstname')">{{
                errors.first('Firstname')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Lastname') }">
              <label>นามสกุล</label>
              <input
                v-validate="'required'"
                name="Lastname"
                :data-vv-as="'Lastname'"
                type="text"
                v-model="inputedit.emp_last_name"
              />
              <span class="text-error" v-if="errors.has('Lastname')">{{
                errors.first('Lastname')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('ชื่อภาษาอังกฤษ') }">
              <label>ชื่อภาษาอังกฤษ</label>
              <input
                v-validate="'required'"
                name="ชื่อภาษาอังกฤษ"
                :data-vv-as="'Name'"
                type="text"
                v-model="inputedit.emp_fullname_en"
              />
              <span class="text-error" v-if="errors.has('ชื่อภาษาอังกฤษ')">{{
                errors.first('ชื่อภาษาอังกฤษ')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Nickname') }">
              <label>ชื่อเล่น</label>
              <input
                v-validate="'required'"
                name="Nickname"
                :data-vv-as="'Nickname'"
                type="text"
                v-model="inputedit.emp_nickname"
              />
              <span class="text-error" v-if="errors.has('Nickname')">{{
                errors.first('Nickname')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Email') }">
              <label>อีเมล์</label>
              <input
                v-validate="'required|email'"
                name="Email"
                :data-vv-as="'Email'"
                type="text"
                v-model="inputedit.emp_email"
              />
              <span class="text-error" v-if="errors.has('Email')">{{ errors.first('Email') }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Phone number') }">
              <label>เบอร์โทรศัพท์</label>
              <input
                v-validate="'required'"
                name="Phone number"
                :data-vv-as="'Phone number'"
                type="text"
                v-model="inputedit.emp_phoneno"
              />
              <span class="text-error" v-if="errors.has('Phone number')">{{
                errors.first('Phone number')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Department') }">
              <label>แผนก</label>
              <input
                v-validate="'required'"
                name="Department"
                :data-vv-as="'Department'"
                type="text"
                v-model="inputedit.department_name"
              />
              <span class="text-error" v-if="errors.has('Department')">{{
                errors.first('Department')
              }}</span>
            </div>
            <div class="form-control" :class="{ 'has-error': errors.has('Position') }">
              <label>ตำแหน่งงาน</label>
              <input
                v-validate="'required'"
                name="Position"
                :data-vv-as="'Position'"
                type="text"
                v-model="inputedit.position_name"
              />
              <span class="text-error" v-if="errors.has('Position')">{{
                errors.first('Position')
              }}</span>
            </div>
            <div>
              <v-btn @click="submitData" depressed block :loading="saveloading" color="primary"
                >บันทึก</v-btn
              >
            </div>
          </v-card-text>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="ictdevices" persistent fullscreen>
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="closeict">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div>
            <div class="text-xs-right">
              <v-btn @click="createict" depressed color="primary">สร้าง</v-btn>
            </div>
            <v-data-table
              expand
              :loading="ictdevicesloading"
              v-bind:pagination.sync="pagination"
              :headers="ictheaders"
              :items="ictdesserts"
              class="elevation-1 scgallrenttable"
            >
              <template v-slot:items="props">
                <tr>
                  <td class="text-xs-center">
                    <!-- <v-avatar size="30"> -->
                    <img
                      v-if="props.item.devicephotourl"
                      :src="props.item.devicephotourl"
                      width="60"
                      height="60"
                      class="ma-1"
                      :alt="props.item.devicephotourl"
                    />
                    <img
                      v-else
                      :src="'/static/img/assets/livechat/profile.png'"
                      width="30"
                      height="30"
                      :alt="props.item.devicephotourl"
                    />
                    <!-- </v-avatar> -->
                  </td>
                  <td class="text-xs-center">{{ props.item.devicename }}</td>
                  <td class="text-xs-center">{{ props.item.devicedetail }}</td>
                  <td class="text-xs-center">
                    {{ props.item.expireat | DateFormat('DD/MM/YYYY') }}
                  </td>
                  <td class="text-xs-center" style="white-space: nowrap">
                    <span
                      @click.stop="onClickeditict(props.item)"
                      :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 25px`"
                      class="material-icons"
                      >create</span
                    >
                    <span
                      @click.stop="deletepttlngictdevices(props.item)"
                      :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 25px`"
                      class="material-icons"
                      >delete_forever</span
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="ictedit" persistent width="600px">
      <v-card>
        <div class="text-xs-right">
          <v-btn icon @click="closeictedit">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text v-if="ictedit">
          <div class="form-control" :class="{ 'has-error': errors.has('Device Name') }">
            <label>ชื่ออุปกรณ์</label>
            <input
              v-validate="'required'"
              name="Device Name"
              :data-vv-as="'Device Name'"
              type="text"
              v-model="inputict.devicename"
            />
            <span class="text-error" v-if="errors.has('Device Name')">{{
              errors.first('Device Name')
            }}</span>
          </div>
          <div class="form-control" :class="{ 'has-error': errors.has('Device Detail') }">
            <label>รายละเอียดอุปกรณ์</label>
            <input
              v-validate="'required'"
              name="Device Detail"
              :data-vv-as="'Device Detail'"
              type="text"
              v-model="inputict.devicedetail"
            />
            <span class="text-error" v-if="errors.has('Device Detail')">{{
              errors.first('Device Detail')
            }}</span>
          </div>

          <v-menu
            ref="showDatePick"
            v-model="showDatePick"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <v-layout>
                <v-flex>
                  <div class="form-control" :class="{ 'has-error': errors.has('Expired At') }">
                    <label>วันหมดอายุ</label>
                    <input
                      placeholder="dd/mm/yyyy"
                      v-validate="'required'"
                      name="Expired At"
                      :data-vv-as="'Expired At'"
                      type="text"
                      v-model="filteredExpireDate"
                      v-on="on"
                      readonly
                    />
                    <span class="text-error" v-if="errors.has('Expired At')">{{
                      errors.first('Expired At')
                    }}</span>
                  </div>
                </v-flex>
              </v-layout>
            </template>
            <v-date-picker
              color="primary"
              v-model="inputict.expireat"
              @input="showDatePick = false"
            ></v-date-picker>
          </v-menu>
          <div class="form-control" :class="{ 'has-error': errors.has('Device Photo') }">
            <label>รายละเอียดอุปกรณ์</label>
            <uploadfile
              v-model="inputict.devicephotourl"
              v-validate="'required'"
              name="Device Photo"
              :data-vv-as="'Device Photo'"
            ></uploadfile>
            <span class="text-error" v-if="errors.has('Device Photo')">{{
              errors.first('Device Photo')
            }}</span>
          </div>
          <v-btn :loading="ictsaveloading" @click="submitIct" depressed color="primary" block
            >บันทึก</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import uploadfile from '@/components/elements/uploadfile'

export default {
  data() {
    return {
      showDatePick: false,
      saveloading: false,
      ictsaveloading: false,
      ictdevicesloading: false,
      edittype: '',
      ictedittype: '',
      ictedit: false,
      ictdevices: false,
      ictdevicesempid: '',
      inputict: {
        devicename: '',
        devicedetail: '',
        devicephotourl: '',
        expireat: '',
        emp_id: ''
      },
      inputedit: {
        emp_title: '',
        department_name: '',
        emp_email: '',
        emp_first_name: '',
        emp_fullname_en: '',
        emp_id: '',
        emp_last_name: '',
        emp_nickname: '',
        emp_phoneno: '',
        position_name: ''
      },
      showeditemp: false,
      loading: true,
      desserts: [],
      ictdesserts: [],
      data: [],
      input: {
        status: ''
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      headers: [
        { text: 'ID', value: 'emp_id', align: 'center', width: '1%' },
        { text: 'ชื่อ', value: 'emp_first_name', align: 'center', width: '1%' },
        { text: 'ชื่อ(ENG)', value: 'emp_fullname_en', align: 'center', width: '1%' },
        { text: 'ตำแหน่งงาน', value: 'position_name', align: 'center', width: '50%' },
        { text: 'แผนก', value: 'department_name', align: 'center', width: '50%' },
        { text: 'อีเมล์', value: 'emp_email', align: 'center', width: '1%' },
        { text: 'เบอร์โทรศัพท์', value: 'emp_phoneno', align: 'center', width: '1%' },
        { text: '', value: 'emp_phoneno', align: 'center', width: '1%' }
      ],
      ictheaders: [
        { text: '', value: 'devicephotourl', align: 'center', width: '1%' },
        { text: 'Device Name', value: 'devicename', align: 'center', width: '1%' },
        { text: 'Detail', value: 'devicedetail', align: 'center', width: '1%' },
        { text: 'Expired Date', value: 'expireat', align: 'center', width: '1%' },
        { text: '', value: 'expireat', align: 'center', width: '1%' }
      ]
    }
  },
  components: {
    uploadfile
  },
  mounted() {
    this.getpttlngalluserprofile()
  },
  computed: {
    filteredExpireDate() {
      if (this.inputict.expireat) {
        return moment(this.inputict.expireat).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  methods: {
    createict() {
      this.ictedittype = 'create'
      this.ictedit = true
    },
    closeictedit() {
      this.inputict = {
        devicename: '',
        devicedetail: '',
        devicephotourl: '',
        expireat: '',
        emp_id: ''
      }
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.ictedittype = ''
      this.ictedit = false
    },
    onClickeditict(val) {
      this.inputict = { ...val, expireat: moment(val.expireat).format('YYYY-MM-DD') }
      this.ictedittype = 'update'
      this.ictedit = true
    },
    closeict() {
      this.ictdevices = false
    },
    submitIct() {
      var vm = this
      this.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (this.ictedittype == 'create') {
          this.postpttlngictdevices()
        }
        if (this.ictedittype == 'update') {
          this.putpttlngictdevices()
        }
      })
    },
    postpttlngictdevices() {
      this.inputict.emp_id = this.ictdevicesempid
      this.ictsaveloading = true
      api.postpttlngictdevices(this.inputict, (err, response) => {
        this.ictdesserts.unshift(this.inputict)
        this.ictsaveloading = false
        this.closeictedit()
      })
    },
    putpttlngictdevices() {
      this.inputict.emp_id = this.ictdevicesempid
      this.ictsaveloading = true
      api.putpttlngictdevices(this.inputict, (err, response) => {
        this.ictsaveloading = false
        var index = this.ictdesserts.findIndex((el) => el.id == this.inputict.id)
        this.$set(this.ictdesserts, index, this.inputict)
        this.closeictedit()
      })
    },
    deletepttlngictdevices(data) {
      var vm = this
      this.$swal
        .fire({
          type: 'question',
          text: 'คุณต้องการลบอุปกรณ์นี้หรือไม่?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            api.deletepttlngictdevices(data, (err, response) => {
              vm.ictdesserts.splice(
                vm.ictdesserts.findIndex((el) => el.id == data.id),
                1
              )
            })
          }
        })
    },
    showictdevices(id) {
      this.ictdevicesempid = id
      this.ictdevices = true
      this.ictdevicesloading = true
      api.getpttlngictdevicesbyempid({ emp_id: id }, (err, response) => {
        this.ictdevicesloading = false
        this.ictdesserts = response.data
      })
    },
    createEmp() {
      this.showeditemp = true
      this.edittype = 'create'
    },
    onClickeditemp(val) {
      this.showeditemp = true
      this.inputedit = JSON.parse(JSON.stringify(val))
      this.edittype = 'update'
    },
    closeedit(cancel) {
      this.inputedit = {
        emp_title: '',
        department_name: '',
        emp_email: '',
        emp_first_name: '',
        emp_fullname_en: '',
        emp_id: '',
        emp_last_name: '',
        emp_nickname: '',
        emp_phoneno: '',
        position_name: ''
      }
      this.$nextTick(() => {
        this.$validator.reset()
      })
      this.edittype = ''
      this.showeditemp = false
    },
    getpttlngalluserprofile() {
      api.getpttlngalluserprofile((err, response) => {
        this.desserts = response.data.rows
        this.loading = false
      })
    },
    deletepttlnguserprofile(data) {
      var vm = this
      this.$swal
        .fire({
          type: 'question',
          text: 'คุณต้องการลบผู้ใช้นี้หรือไม่?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            api.deletepttlngalluserprofile(data, (err, response) => {
              vm.desserts.splice(
                vm.desserts.findIndex((el) => el.id == data.id),
                1
              )
            })
          }
        })
    },
    submitData() {
      var vm = this
      this.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (this.edittype == 'create') {
          this.postpttlnguserprofile()
        }
        if (this.edittype == 'update') {
          this.putpttlnguserprofile()
        }
      })
    },
    putpttlnguserprofile() {
      this.saveloading = true
      api.putpttlnguserprofile(this.inputedit, (err, response) => {
        this.saveloading = false
        var index = this.desserts.findIndex((el) => el.id == this.inputedit.id)
        this.$set(this.desserts, index, this.inputedit)
        this.closeedit()
      })
    },
    postpttlnguserprofile() {
      this.saveloading = true
      api.postpttlnguserprofile(this.inputedit, (err, response) => {
        this.saveloading = false
        if (response.data.length) {
          this.desserts.unshift(this.inputedit)
          this.closeedit()
        } else {
          this.$swal.fire({ text: 'ID นี้มีผู้ใช้งานแล้ว กรุณาใช้ ID อื่น' })
        }
      })
    }
  },
  filters: {
    phonefilter: function (value) {
      return value.replace(',', '\n')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/pttlng/Employee.vue